var React = require('react');

function Apple (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.7516 12.5953C17.7422 10.875 18.5203 9.57656 20.0953 8.62031C19.2141 7.35938 17.8828 6.66563 16.125 6.52969C14.4609 6.39844 12.6422 7.5 11.9766 7.5C11.2734 7.5 9.66094 6.57656 8.39531 6.57656C5.77969 6.61875 3 8.6625 3 12.8203C3 14.0484 3.225 15.3172 3.675 16.6266C4.275 18.3469 6.44062 22.5656 8.7 22.4953C9.88125 22.4672 10.7156 21.6563 12.2531 21.6563C13.7437 21.6563 14.5172 22.4953 15.8344 22.4953C18.1125 22.4625 20.0719 18.6281 20.6437 16.9031C17.5875 15.4641 17.7516 12.6844 17.7516 12.5953V12.5953ZM15.0984 4.89844C16.3781 3.37969 16.2609 1.99688 16.2234 1.5C15.0938 1.56563 13.7859 2.26875 13.0406 3.13594C12.2203 4.06406 11.7375 5.2125 11.8406 6.50625C13.0641 6.6 14.1797 5.97188 15.0984 4.89844V4.89844Z","fill":"black"}));
}

Apple.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Apple;

Apple.default = Apple;
